import { request } from "./http";

export const listAppointments = (params?: { start?: string; end?: string; employee_id?: number }) => {
  const q = new URLSearchParams();
  if (params?.start) q.set("start", params.start);
  if (params?.end) q.set("end", params.end);
  if (params?.employee_id) q.set("employee_id", String(params.employee_id));
  const qs = q.toString();
  return request<any[]>(`/api/appointments${qs ? `?${qs}` : ""}`);
};

export const getAppointment = (id: number) =>
  request<any>(`/api/appointments/${id}`);

export const listClientAppointments = (clientId: number | string, params?: { limit?: number; offset?: number }) => {
  const q = new URLSearchParams();
  if (params?.limit) q.set("limit", String(params.limit));
  if (params?.offset) q.set("offset", String(params.offset));
  const qs = q.toString();
  return request<any[]>(`/api/clients/${clientId}/appointments${qs ? `?${qs}` : ""}`);
};


export const createAppointment = (body: {
  client_id: number | string | null;
  employee_id: number | string;
  start_datetime: string;
  duration_minutes: number;
  room_id: number | null;
  notes?: string | null;
  is_recurring?: boolean;
  specialty_id?: number | null;
  payment_amount_cents?: number;
  payment_status?: 'pending' | 'paid';
  insurance_provider_id?: number | null;
}) => {
  console.log("createAppointment - Request body:", body);
  const res = request<{ id: number }>(`/api/appointments`, { method: "POST", body: JSON.stringify(body) });
  res.then(data => console.log("createAppointment - Response:", data));
  return res;
};



export const updateAppointment = (
  id: number,
  body: Partial<{
    client_id: number | string | null;
    employee_id: number | string;
    start_datetime: string;
    duration_minutes: number;
    room_id: number | null;
    done: boolean | number | string;
    notes: string | null;
    evolution: string | null;
    specialty_id: number | null;
    insurance_provider_id: number | null;
  }>
) => request<Partial<import("../types").Appointment>>(`/api/appointments/${id}`, { method: "PUT", body: JSON.stringify(body) });

export const deleteAppointment = (id: number) => request<void>(`/api/appointments/${id}`, { method: "DELETE" });

export const deleteRecurringAppointments = (id: number) => request<void>(`/api/appointments/recurring/${id}`, { method: "DELETE" });

export const updateRecurringAppointments = (
  groupId: number,
  body: Partial<{
    appointment_id: number;
    employee_id: number;
    start_datetime: string;
    duration_minutes: number;
    room_id: number | null;
    specialty_id: number | null;
    notes: string | null;
  }>
) => request(`/api/appointments/recurring/${groupId}`, { method: "PUT", body: JSON.stringify(body) });
